//Fix Search Dropdown

var search = $('#search');
search.click(function(e){
 var searchBox = $('#shopify-section-header #searchBox');
  e.preventDefault();
 searchBox.toggleClass('show');
});

$(document).mouseup(function(e){
    var container = $("#shopify-section-header #searchBox");
 
    // If the target of the click isn't the container
    if(!container.is(e.target) && container.has(e.target).length === 0){
        container.removeClass('show');
    }
});

//Dropdown Menu Adjustment

function dropdownPosition() {
  var dropdown = $('.dropdown_container.simple_dropdown');
  var parent = $('[ data-dropdown-rel=' + dropdown.data('dropdown') + ']').parent();
  var position = parent.offset().left - 300 + (parent.width() * 2);
  dropdown.css('left', position + 'px');
}

$( document ).ready(function() {
	dropdownPosition();
});

$( window ).resize(function() {
  dropdownPosition();
});


// Offset anchor links
function anchorOffset() {
  $('a[href*="#"]:not([href="#"])').not('.tabs li a').click(function() {
    var offset = -60; // <-- change the value here
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top + offset
            }, 1000);
            return false;
        }
    }
});
}

$( document ).ready(function() {
	anchorOffset();
});

$( window ).resize(function() {
  anchorOffset();
});



//Collection list slider
var collectionlistSlider = {
  init: function() {
    $('.js-collection-slider .collection-slider').each(function (index, value) {
      var arrowShow = $(this).find(".gallery-cell").length === 1 ? false : true;
      $(this).flickity({
          lazyLoad: 2,
          wrapAround: true,
          cellAlign: "left",
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          pageDots: arrowShow,
          arrowShape: arrowSize,
          percentPosition: false,
        });
    });
  }
}

$( document ).ready(function() {
	collectionlistSlider.init();
});

$(document).on('shopify:section:load', function() {
  	collectionlistSlider.init();
});


//Featured collection product slider
var featuredcollectionSlider = {
  init: function() {
    $('.js-featured-product-slider .new-product-slider').each(function (index, value) {
      var arrowShow = $(this).find(".gallery-cell").length === 1 ? false : true;
      $(this).flickity({
        lazyLoad: 2,
        wrapAround: true,
        cellAlign: "left",
        imagesLoaded: true,
        prevNextButtons: arrowShow,
        draggable: arrowShow,
        pageDots: arrowShow,
        arrowShape: arrowSize,
        percentPosition: false,
      });
    });
  }
}

$( document ).ready(function() {
	featuredcollectionSlider.init();
});

$(document).on('shopify:section:load', function() {
  	featuredcollectionSlider.init();
});

//Product block slider
var productblockSlider = {
  init: function() {
    $('.js-product-block-slider .product-block-slider').each(function (index, value) {
      var arrowShow = $(this).find(".gallery-cell").length === 1 ? false : true;
      $(this).flickity({
        lazyLoad: 2,
        wrapAround: true,
        cellAlign: "left",
        imagesLoaded: true,
        prevNextButtons: arrowShow,
        draggable: arrowShow,
        pageDots: arrowShow,
        arrowShape: arrowSize,
        percentPosition: false,
      });
    });
  }
}

$( document ).ready(function() {
	productblockSlider.init();
});

$(document).on('shopify:section:load', function() {
  	productblockSlider.init();
});

//Slider Button Height Adjustments jQuery
function resizeSliderButtons() {
  var slider = $('.slider-gallery');
  var height = slider.find('.gallery-cell .image-element__wrap img').height();
  slider.find('.flickity-prev-next-button').height( height );
}

$( document ).ready(function() {
	resizeSliderButtons();
});

$( window ).resize(function() {
  resizeSliderButtons();
});


